import React from "react"
import { Grid, Typography, IconButton, Box } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {ParallaxLayer} from 'react-spring/renderprops-addons';

import Office from "../svgs/office.inline.svg"
import Blob from "../svgs/blob.inline.svg"

const links = [
    { icon: ["fab", "linkedin"], url: "https://www.linkedin.com/in/jeff-canale-42509b135" },
    { icon: ["fab", "dev"], url: "https://dev.to/jepoy" },
    { icon: ["fab", "github-square"], url: "https://github.com/je-poy" },
    { icon: ["fab", "instagram"], url: "https://www.instagram.com/_amejisuto" }
]

function Header(props) {
    const textColor = props.darkMode ? 'textSecondary' : 'textPrimary'
    return <div>
        <ParallaxLayer
            offset={0.1}
            speed={0.1} 
            style={{
                marginLeft: "-15%"
            }}
        >
            <Office
                style={{
                    height: '90%'
                }}
            />
        </ParallaxLayer>

        <ParallaxLayer offset={.4} speed={.5} >
            <Typography 
                variant="h3" 
                align="right" 
                color="secondary"
                style={{
                    marginRight: '2%'
                }}
            >
                <Box fontWeight="fontWeightRegular" >
                    know this thing, the so-called 'jepoy'.
                </Box>
            </Typography>
            <Typography 
                variant="subtitle1" 
                align="right"
                color={textColor}
                style={{
                    marginRight: '2%'
                }}
            >
                - a Full-Stack Developer
            </Typography>
        </ParallaxLayer>

        <ParallaxLayer offset={.53} speed={-0.2} >
            <Blob
                style={{
                    marginLeft: '70%',
                    width: 250
                }}
            />
        </ParallaxLayer>
        <ParallaxLayer offset={.61} speed={-0.1} >
            <Blob 
                style={{
                    marginLeft: '66%',
                    width: 220
                }}
            />
        </ParallaxLayer>
        <ParallaxLayer offset={.63} speed={-0.1}>
            <Grid
                container item 
                justify="flex-start"
                alignItems="center" 
                style={{
                    marginLeft: '68%'
                }}
            >
                {links.map((link, index) => {
                    return (
                        <IconButton 
                            key={`link-icon-${index}`}
                            href={link.url} 
                            color={textColor}
                        >
                            <FontAwesomeIcon icon={link.icon} size="2x" />
                        </IconButton>
                    )
                })}
            </Grid>
        </ParallaxLayer>

    </div>
}

export default Header